import { render, staticRenderFns } from "./stockout_edit.vue?vue&type=template&id=6b2b86ff&scoped=true"
import script from "./stockout_edit.vue?vue&type=script&lang=js"
export * from "./stockout_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b86ff",
  null
  
)

export default component.exports